import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
export default function Login() {
  const { login } = useAuth();
  const [phone, setPhone] = useState('');
  const [pass,  setPass]  = useState('');
  const [err,   setErr]   = useState('');
  const [load,  setLoad]  = useState(false);
  const submit = async e => {
    e.preventDefault(); setErr(''); setLoad(true);
    try { await login(phone, pass); }
    catch(e) { setErr(e.response?.data?.error || e.message); }
    finally { setLoad(false); }
  };
  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a1a2e,#16213e)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'sans-serif'}}>
      <div style={{background:'#1e293b',borderRadius:'20px',padding:'40px',width:'360px',border:'1px solid #334155',textAlign:'center'}}>
        <div style={{fontSize:'48px',marginBottom:'8px'}}>🏢</div>
        <h1 style={{color:'#f1f5f9',fontSize:'22px',fontWeight:'900',margin:'0 0 4px'}}>بوابة الشركات</h1>
        <p style={{color:'#64748b',fontSize:'13px',margin:'0 0 28px'}}>منصة بسرعة للتوصيل</p>
        <form onSubmit={submit} dir="rtl">
          <div style={{marginBottom:'14px',textAlign:'right'}}>
            <label style={{display:'block',color:'#94a3b8',fontSize:'13px',marginBottom:'5px'}}>رقم الهاتف</label>
            <input style={{width:'100%',padding:'12px',background:'#0f172a',border:'1px solid #334155',borderRadius:'8px',color:'#f1f5f9',fontSize:'15px',boxSizing:'border-box',outline:'none',direction:'ltr'}}
              type="tel" value={phone} onChange={e=>setPhone(e.target.value)} placeholder="01xxxxxxxxx" required/>
          </div>
          <div style={{marginBottom:'20px',textAlign:'right'}}>
            <label style={{display:'block',color:'#94a3b8',fontSize:'13px',marginBottom:'5px'}}>كلمة المرور</label>
            <input style={{width:'100%',padding:'12px',background:'#0f172a',border:'1px solid #334155',borderRadius:'8px',color:'#f1f5f9',fontSize:'15px',boxSizing:'border-box',outline:'none'}}
              type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" required/>
          </div>
          {err && <div style={{background:'#450a0a',border:'1px solid #7f1d1d',borderRadius:'8px',padding:'10px',color:'#fca5a5',fontSize:'13px',marginBottom:'14px'}}>{err}</div>}
          <button style={{width:'100%',padding:'13px',background:'linear-gradient(135deg,#3b82f6,#1d4ed8)',border:'none',borderRadius:'10px',color:'#fff',fontSize:'15px',fontWeight:'bold',cursor:'pointer'}}
            type="submit" disabled={load}>{load?'جاري الدخول...':'دخول →'}</button>
        </form>
      </div>
    </div>
  );
}
